<script lang="ts" setup>
  import '@tato30/vue-pdf/style.css'

  import { onMounted, onUnmounted, ref } from 'vue'
  import type { VNodeRef } from 'vue'
  import { usePDF } from '@/store/pdfStore'
  import { VuePDF } from '@tato30/vue-pdf'
  import type { PDFDocumentLoadingTask } from 'pdfjs-dist/legacy/build/pdf'
  import { UAParser } from 'ua-parser-js'

  defineProps({
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  })
  // @ts-ignore
  const pdf = usePDF()
  const vuePDFRef = ref<VNodeRef | undefined>(undefined)

  function handleWindowSizeChange() {
    // handling resize on Android devices is not working properly
    // so we only reload the pdf on resizes on other devices
    const parser = new UAParser()
    parser.setUA(window.navigator.userAgent)
    const result = parser.getResult()
    if (result.os.name !== 'Android') {
      if (vuePDFRef.value) {
        vuePDFRef.value.reload()
      }
    }
  }

  onMounted(() => {
    window.addEventListener('resize', handleWindowSizeChange)
  })

  onUnmounted(async () => {
    window.removeEventListener('resize', handleWindowSizeChange)
  })
</script>

<template>
  <div>
    <VuePDF
      v-if="pdf.loadingTask"
      ref="vuePDFRef"
      class="pdf"
      data-cy="pdfDisplayDiv"
      annotation-layer
      fit-parent
      on-layer
      text-layer
      :annotations-map="pdf.annotationStorage"
      :hide-forms="!pdf.editable || !editable"
      :page="pdf.page"
      :pdf="pdf.loadingTask as PDFDocumentLoadingTask"
      @annotation="pdf.onAnnotation"
      @loaded="pdf.onLoaded"
    ></VuePDF>
    <div
      v-else
      class="spinner-border"
      role="status"
    ></div>
    <!-- <div
    class="debug-warning"
    v-else>
    Not rendering VuePDF container because
    <span class="debug-highlight">form.pdf</span> is {{ typeof form.pdf }}.
</div> -->
  </div>
</template>
